import { Persistent, CadmoOperator, AgaveService } from 'tq-agave';


export type ICompanyUser_Key = { company_id: string; user_id: string;  };

export interface ICompanyUser_Field {
    company_id: string;
    user_id: string;
    imsign_group?: any;
    email: string;
    name?: string;
    surname?: string;
    notify_01?: boolean;
    created_by: any;
    created_on_utc: Date;
    modified_by: any;
    modified_on_utc: Date;
    filter_full?: any;
}

export interface ICompanyUser_Insert {
    company_id: string;
    user_id: string;
    imsign_group?: any;
    email: string;
    name?: string;
    surname?: string;
    notify_01?: boolean;
    created_by?: any;
    created_on_utc?: Date;
    modified_by?: any;
    modified_on_utc?: Date;
    filter_full?: any;
}

// Persistent automatico per la page RMS_A_company_user
// Importante! Ogni modifica fatta a questo file sara' persa al prossimo refresh persistent.
// Importante! Non utilizzare direttamente questa classe. Usare invece ../CompanyUser
export class CompanyUser_BASE extends Persistent<ICompanyUser_Field> {

    static fieldList: string[] = [
        'company_id',
        'user_id',
        'imsign_group',
        'email',
        'name',
        'surname',
        'notify_01',
        'created_by',
        'created_on_utc',
        'modified_by',
        'modified_on_utc',
        'filter_full',
    ];

    static keyList: string[] = [
        'company_id',
        'user_id',
    ];

    static updateFieldList: string[] = [
        'imsign_group',
        'email',
        'name',
        'surname',
        'notify_01',
        'created_by',
        'created_on_utc',
        'modified_by',
        'modified_on_utc',
        'filter_full',
    ];

    company_id?: string;
    user_id?: string;
    imsign_group?: any;
    email?: string;
    name?: string;
    surname?: string;
    notify_01?: boolean;
    created_by?: any;
    created_on_utc?: Date;
    modified_by?: any;
    modified_on_utc?: Date;
    filter_full?: any;

    operators: {
        company_id?: CadmoOperator;
        user_id?: CadmoOperator;
        imsign_group?: CadmoOperator;
        email?: CadmoOperator;
        name?: CadmoOperator;
        surname?: CadmoOperator;
        notify_01?: CadmoOperator;
        created_by?: CadmoOperator;
        created_on_utc?: CadmoOperator;
        modified_by?: CadmoOperator;
        modified_on_utc?: CadmoOperator;
        filter_full?: CadmoOperator;
    } = {};

    constructor(value?: any) {
        super();
        if (value) {
            this.company_id = value['company_id'];
            this.user_id = value['user_id'];
            this.imsign_group = value['imsign_group'];
            this.email = value['email'];
            this.name = value['name'];
            this.surname = value['surname'];
            this.notify_01 = AgaveService.getBooleanFrom01(value['notify_01']);
            this.created_by = value['created_by'];
            this.created_on_utc = AgaveService.getDateFromEpoch(value['created_on_utc']);
            this.modified_by = value['modified_by'];
            this.modified_on_utc = AgaveService.getDateFromEpoch(value['modified_on_utc']);
            this.filter_full = value['filter_full'];
        }
    }

    getPage(): string {
        return 'RMS_A_company_user';
    }

    getCadmoParams(): any {
        const r: any = {};
        if (this.company_id !== undefined) {
            r.company_id = this.company_id;
        }
        if (this.user_id !== undefined) {
            r.user_id = this.user_id;
        }
        if (this.imsign_group !== undefined) {
            r.imsign_group = this.imsign_group;
        }
        if (this.email !== undefined) {
            r.email = this.email;
        }
        if (this.name !== undefined) {
            r.name = this.name;
        }
        if (this.surname !== undefined) {
            r.surname = this.surname;
        }
        if (this.notify_01 !== undefined) {
            r.notify_01 = AgaveService.get01FromBoolean(this.notify_01);
        }
        if (this.created_by !== undefined) {
            r.created_by = this.created_by;
        }
        if (this.created_on_utc !== undefined) {
            r.created_on_utc = AgaveService.getEpochFromDate(this.created_on_utc);
        }
        if (this.modified_by !== undefined) {
            r.modified_by = this.modified_by;
        }
        if (this.modified_on_utc !== undefined) {
            r.modified_on_utc = AgaveService.getEpochFromDate(this.modified_on_utc);
        }
        if (this.filter_full !== undefined) {
            r.filter_full = this.filter_full;
        }
        return r;
    }

    getCadmoKeys(): any {
        return {
            company_id: this.company_id,
            user_id: this.user_id,
        };
    }

    getCadmoOperators(): any {
        return {
            _operator_company_id: this.operators.company_id,
            _operator_user_id: this.operators.user_id,
            _operator_imsign_group: this.operators.imsign_group,
            _operator_email: this.operators.email,
            _operator_name: this.operators.name,
            _operator_surname: this.operators.surname,
            _operator_notify_01: this.operators.notify_01,
            _operator_created_by: this.operators.created_by,
            _operator_created_on_utc: this.operators.created_on_utc,
            _operator_modified_by: this.operators.modified_by,
            _operator_modified_on_utc: this.operators.modified_on_utc,
            _operator_filter_full: this.operators.filter_full,
        };
    }

}

